const NIGHTS_PREFIX_PATTERN = /^\d+N\s+/;
const ADULTS_SUFFIX_PATTERN = /\s+\d+A(\d+C)?\b.*$/i;

export function parseRoomNameFromDealName(dealName: string | null | undefined) {
  const trimmedName = dealName?.trim();
  if (!trimmedName) {
    return undefined;
  }

  const withoutNightsPrefix = trimmedName.replace(NIGHTS_PREFIX_PATTERN, '');
  const withoutAdultsSuffix = withoutNightsPrefix.replace(ADULTS_SUFFIX_PATTERN, '').trim();

  return withoutAdultsSuffix || undefined;
}
